/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
(function customFlickityCounter(root) {
  root = root || document;

  var widgets = [].slice.call(root.querySelectorAll('[data-mobile-dots]'));
  if (!widgets.length) return;

  widgets.forEach(setupCounter);

  function setupCounter(wrap) {
    var counterEl = wrap.querySelector('.product__mobile-dots-counter');
    var dotsContainer = wrap.querySelector('.flickity-page-dots');
    if (!counterEl || !dotsContainer) return;

    var dots = [].slice.call(dotsContainer.querySelectorAll('[data-mobile-dot]'));
    var total = dots.length;
    if (!total) return;

    function selectedIndex() {
      var idx = dots.findIndex(function (d) { return d.classList.contains('is-selected'); });
      return idx >= 0 ? idx : 0;
    }

    function update(i) {
      if (i < 0) i = 0;
      if (i >= total) i = total - 1;
      counterEl.textContent = (i + 1) + '/' + total;
    }
    update(selectedIndex());

    dots.forEach(function (btn, idx) {
      btn.addEventListener('click', function () { update(idx); });
    });

    var mo = new MutationObserver(function () { update(selectedIndex()); });
    mo.observe(dotsContainer, { subtree: true, attributes: true, attributeFilter: ['class'] });
  }
})(document);

document.addEventListener("DOMContentLoaded", function() {
  let selectBtn = document.getElementById("select-size-btn");
  let variantContainer = document.getElementById("variant-container");

  if (selectBtn && variantContainer) {
    selectBtn.addEventListener("click", function(event) {
      event.preventDefault();
      selectBtn.style.display = "none";        
      variantContainer.classList.remove("hidden");
    });
  }

  // Sort filter functionality
  function initSortFilter() {
    const sortButtonText = document.querySelector('[data-sort-button-text]');
    const sortContainer = document.querySelector('.popout--sort');
    
    if (!sortButtonText || !sortContainer) return;

    function updateButtonText(text) {
      sortButtonText.textContent = `(${text})`;
    }

    function updateSortState() {
      const sortBy = new URLSearchParams(window.location.search).get('sort_by');
      const popout = sortContainer.querySelector('.popout');
      
      // Remove is-active class from all items first
      sortContainer.querySelectorAll('.popout-list__item').forEach(item => {
        item.classList.remove('is-active');
      });
      
      if (!sortBy) {
        // No sort selected - remove is-active class and reset button text
        popout.classList.remove('is-active');
        sortButtonText.textContent = '';
        return;
      }

      const sortOption = document.querySelector(`[data-sort-link][data-value="${sortBy}"]`);
      if (sortOption) {
        popout.classList.add('is-active');
        updateButtonText(sortOption.textContent.trim());
        sortOption.closest('.popout-list__item')?.classList.add('is-active');
      }
    }

    // Event delegation for sort links
    sortContainer.addEventListener('click', (e) => {
      const sortLink = e.target.closest('[data-sort-link]');
      if (sortLink) {
        updateButtonText(sortLink.textContent.trim());
      }
    });

    window.addEventListener('popstate', updateSortState);
    updateSortState();
  }

  // Initialize and reinitialize on section load
  initSortFilter();
  document.addEventListener('shopify:section:load', initSortFilter);
});
  class HeaderState {
    constructor() {
      this.header = document.querySelector('header-component');
      this.drawerBody = document.querySelector('.drawer__body');
      this.announcementBar = document.querySelector('announcement-bar');
      this.isStuck = false;
      this.isMobile = window.innerWidth < 750;

      this.init();
    }

    init() {
      if (!this.header || !this.drawerBody || !this.isMobile) return;

      this.updateState();
      this.updateDrawerMargin();

      this.observer = new MutationObserver(() => {
        if (!this.isMobile) return;
        this.updateState();
        this.updateDrawerMargin(); 
      });
      
      this.observer.observe(this.header, {
        attributes: true,
        attributeFilter: ['class']
      });

      window.addEventListener('scroll', () => {
        if (!this.isMobile) return;
        this.updateState();
        this.updateDrawerMargin();
      });

      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 750;
        if (!this.isMobile) {
          this.drawerBody.style.marginTop = '0px';
          return;
        }
        this.updateState();
        this.updateDrawerMargin();
      });
    }

    updateState() {
      if (!this.isMobile) return;
      this.isStuck = this.header.classList.contains('js__header__stuck');
    }

    getAnnouncementBarHeight() {
      if (!this.announcementBar || !this.isMobile) return 0;
      
      if (this.isStuck) return 0;
      
      const rect = this.announcementBar.getBoundingClientRect();
      return rect.height;
    }

    updateDrawerMargin() {
      if (!this.isMobile) return;
      const announcementHeight = this.getAnnouncementBarHeight();
      const baseMargin = 0;
      const totalMargin = baseMargin + announcementHeight;
      
      this.drawerBody.style.marginTop = `${totalMargin}px`;
    }
  }
  new HeaderState();


  function signupForWaitlist() {
    const signupButton = document.querySelector('.btn-waitlist');
    if (!signupButton) return;
  
    const signupModal = document.querySelector('.product__waitlist_modal');
    const releaseName = signupButton.dataset.releaseName;
    
    if (!signupModal) {
      console.warn('Waitlist modal not found');
      return;
    }

    const signupSubmit = signupModal.querySelector('.product__waitlist_modal-submit');
    const errorField = signupModal.querySelector('.error-field');
    const successField = signupModal.querySelector('.success-field');
  
    if (!signupSubmit || !errorField || !successField) {
      console.warn('Required waitlist modal elements not found');
      return;
    }
  
    signupButton.addEventListener('click', (e) => {
      e.preventDefault();
      if (signupModal) {
        signupModal.classList.add('active');
      }
    });
  
    signupSubmit.addEventListener('click', (e) => {
      e.preventDefault();
      
      const emailInput = signupModal.querySelector("input[type='email']");
      if (!emailInput) {
        console.error('Email input not found');
        return;
      }
      
      const email = emailInput.value.trim();
      errorField.innerHTML = '';
      successField.innerHTML = '';
  
      // Validate email
      if (!email || !email.includes('@') || !email.includes('.')) {
        errorField.innerHTML = window.theme?.strings?.waitlist_email_error || 'Please enter a valid email address';
        return;
      }
  
      if (!releaseName) {
        errorField.innerHTML = window.theme?.strings?.waitlist_error || 'Release name not found';
        return;
      }
  
      // Disable submit button and show loading state
      signupSubmit.classList.add('disabled');
      const originalText = signupSubmit.innerHTML;
      signupSubmit.innerHTML = window.theme?.strings?.waitlist_submitting || 'Submitting...';
      signupSubmit.disabled = true;
  
      // Get product information
      const productTitle = document.querySelector('.main-product__title')?.innerText?.trim() || 
                          document.querySelector('h1')?.innerText?.trim() || 
                          'Product';
      const productId = document.querySelector('.product__release')?.getAttribute('data-product-id') || 
                       document.querySelector('[data-product-id]')?.getAttribute('data-product-id');
  
      const subscribePayload = {
        email,
        releaseName,
        productId: productId,
        productTitle: productTitle,
      };
  
      fetch(`https://planetnusa-backend-323660974935.europe-west1.run.app/api/waitlist/signup`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(subscribePayload),
      })
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then(() => {
          successField.innerHTML = window.theme?.strings?.waitlist_success || 'Successfully signed up for waitlist!';
          emailInput.value = ''; // Clear the email input
        })
        .catch((error) => {
          console.error('Waitlist signup error:', error);
          errorField.innerHTML = window.theme?.strings?.waitlist_error || 'An error occurred. Please try again.';
        })
        .finally(() => {
          // Re-enable submit button
          signupSubmit.classList.remove('disabled');
          signupSubmit.innerHTML = originalText;
          signupSubmit.disabled = false;
        });
    });
  
  }
  
  function signupModalClose() {
    const signupModal = document.querySelector('.product__waitlist_modal');
    if (!signupModal) return;

    const signupCloseButton = signupModal.querySelector('.close');
    const signupOverlay = signupModal.querySelector('.product__waitlist_modal-overlay');
  
    const closeModal = () => {
      signupModal.classList.remove('active');
    };

    // Close button
    if (signupCloseButton) {
      signupCloseButton.addEventListener('click', closeModal);
    }

    // Overlay click
    if (signupOverlay) {
      signupOverlay.addEventListener('click', closeModal);
    }

    // ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && signupModal.classList.contains('active')) {
        closeModal();
      }
    });
  }
  
  // Initialize coming soon functionality
  signupModalClose();
  signupForWaitlist();

  // Rebuy setup
  document.addEventListener("rebuy:smartcart.ready", (event) => {
  const cart = event.detail?.smartcart?.cart || event.detail?.cart?.cart || event.detail?.cart || null;

  addShippingInfo();
    addPaymentIcons();
  setTimeout(() => {
    addSiblingColorSwatches();
  }, 100);
    
  // Run every 100ms
  setInterval(addSiblingColorSwatches, 500);
});

// Smart Cart Change (handles add, remove, quantity changes, etc.)
document.addEventListener("rebuy:cart.change", (event) => {
  const cart = event.detail?.smartcart?.cart || event.detail?.cart?.cart || event.detail?.cart || null;

  addShippingInfo();
  addPaymentIcons();

  setTimeout(() => {
    addSiblingColorSwatches();
  }, 100);

  // make sure the "Total" span gets text content when the rebuy cart is ready after changing
  const totalElement = document.querySelector('.rebuy_total_amount_div .rebuy_total_text');
  if (totalElement) {
    totalElement.textContent = window.theme.strings.orderTotal;
  }
})

function addPaymentIcons() {
  setTimeout(() => {
    const paymentIcons = document.querySelector(
      "ul.cart__drawer__payment__icons"
    );
    const checkoutArea = document.querySelector(
      'div[data-rebuy-component="checkout-area"]'
    );

    if (checkoutArea && paymentIcons) {
      const existingPaymentIcons = checkoutArea.querySelector(
        "ul.cart__drawer__payment__icons"
      );
      if (existingPaymentIcons) {
        existingPaymentIcons.remove();
      }

      const clonedPaymentIcons = paymentIcons.cloneNode(true);
      checkoutArea.appendChild(clonedPaymentIcons);
    }
  }, 500);
}

function addSiblingColorSwatches() {
  // Find all color variant containers in the Rebuy cart
  const rebuyVariantsWithoutSwatches = [...document
    .querySelectorAll('.rebuy-cart__flyout-item-variant--color')]
    .filter(variant => !variant.querySelector('.cart__item__variant-swatches'));
  
  if (rebuyVariantsWithoutSwatches.length > 0) {
    rebuyVariantsWithoutSwatches.forEach((rebuyVariant, index) => {
      // Find the Rebuy cart item to get product information
      const rebuyItem = rebuyVariant.closest('.rebuy-cart__flyout-item');
      if (!rebuyItem) {
        console.warn('No rebuy item found for variant', index);
        return;
      }
      
      // Get the product title
      const rebuyProductTitle = rebuyItem.querySelector('.rebuy-cart__flyout-item-product-title')?.textContent?.trim();
      
      if (!rebuyProductTitle) {
        console.warn('No product title found for rebuy item', index);
        return;
      }
      
      // Create swatches container
      const swatchesContainer = document.createElement('div');
      swatchesContainer.className = 'cart__item__variant-swatches';
      
      // Try to find the main cart item with the same product title to get the swatches
      const themeCartItems = document.querySelectorAll('.cart__item');
      let matchingThemeCartItem = null;
      
      for (const themeCartItem of themeCartItems) {
        const mainCartTitle = themeCartItem.querySelector('.cart__item__title a')?.textContent?.trim();
        if (mainCartTitle === rebuyProductTitle) {
          matchingThemeCartItem = themeCartItem;
          break;
        }
      }
      
      if (matchingThemeCartItem) {
        const mainCartSwatches = matchingThemeCartItem.querySelector('.cart__item__variant-swatches');

        if (mainCartSwatches) {
          const clonedSwatches = mainCartSwatches.cloneNode(true);
          swatchesContainer.appendChild(clonedSwatches);
          rebuyVariant.appendChild(swatchesContainer);
        }
      } else {
        console.warn(`${rebuyProductTitle} - Has no matching main cart item`);
      }
    });
  }
}


function addShippingInfo() {
  setTimeout(() => {
    const estimatedDelivery = document.querySelector(".estimated-delivery");

    if (!estimatedDelivery) {
      return;
    }
    const cartFooter = document.querySelector(
      'div[data-rebuy-cart-anchor="footer"]'
    );

    if (!cartFooter) {
      return;
    }

    const existingEstimatedDelivery = cartFooter.querySelector(
      ".estimated-delivery"
    );
    if (
      existingEstimatedDelivery &&
      existingEstimatedDelivery !== estimatedDelivery
    ) {
      existingEstimatedDelivery.remove();
    }

    const cartSubtotal = cartFooter.querySelector(
      'div[data-rebuy-component="cart-subtotal"]'
    );

    const checkoutArea = cartFooter.querySelector(
      'div[data-rebuy-component="checkout-area"]'
    );
    const clonedEstimatedDelivery = estimatedDelivery.cloneNode(true);
    if (checkoutArea && cartSubtotal) {
      checkoutArea.insertAdjacentElement(
        "beforebegin",
        clonedEstimatedDelivery
      );
    } else if (cartSubtotal) {
      cartSubtotal.insertAdjacentElement("afterend", clonedEstimatedDelivery);
    } else {
      cartFooter.appendChild(clonedEstimatedDelivery);
    }
  }, 500);
}

addShippingInfo();

const currencySymbols = {
  'kr': 'kr',
  'dkk': 'kr',
  "DKK": "kr",
  "EUR": "€",
  "USD": "$",
  "GBP": "£"
};

// Helper function to format currency like Rebuy does
function formatCurrency(amountInCents, currency) {
  const amount = amountInCents / 100;
  
  const symbol = currencySymbols[currency] || currency;
  
  if (currency === 'DKK' || currency === 'dkk' || currency === 'kr') {
    return `${symbol} ${amount.toLocaleString('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  } else {
    return `${symbol}${amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
}

function getMarketHandle() {
  const country = Shopify.country.toLowerCase();
  
  const marketMap = {
    'dk': 'denmark',
    'us': 'usa',
    'gb': 'uk',
    'eu': 'europe',
  }

  return marketMap[country] || 'denmark'; // Default to denmark instead of 'en'
}

// Helper function to get cart data from multiple sources
function getCartData(providedCart = null) {
  let subtotalPrice = 0;
  
  // Try provided cart first
  if (providedCart?.items_subtotal_price) {
    subtotalPrice = providedCart.items_subtotal_price;
    return subtotalPrice;
  }
  
  // Try rebuy cart
  if (window.rebuyCart?.cart?.items_subtotal_price) {
    subtotalPrice = window.rebuyCart.cart.items_subtotal_price;
    return subtotalPrice;
  }
  
  // Try Shopify cart
  if (typeof Shopify !== 'undefined' && Shopify.cart?.total_price) {
    subtotalPrice = Shopify.cart.total_price;
    return subtotalPrice;
  }
  
  return 0;
}

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
